import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { formatDistanceToNow } from 'date-fns';
import Icon from './AppIcon';
import Button from './ui/Button';

const TwoFAReminderBanner = () => {
  const navigate = useNavigate();
  const { userProfile, is2FAEnabled } = useAuth();
  const [showBanner, setShowBanner] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState('');

  const updateTimeRemaining = () => {
    if (userProfile?.twofa_setup_deadline) {
      const deadline = new Date(userProfile?.twofa_setup_deadline);
      const remaining = formatDistanceToNow(deadline, { addSuffix: true });
      setTimeRemaining(remaining);
    }
  };

  useEffect(() => {
    if (!is2FAEnabled && userProfile?.twofa_setup_deadline) {
      const deadline = new Date(userProfile?.twofa_setup_deadline);
      const now = new Date();

      if (now < deadline) {
        setShowBanner(true);
        updateTimeRemaining();

        const interval = setInterval(updateTimeRemaining, 60000); // Update every minute
        return () => clearInterval(interval);
      }
    }
  }, [userProfile, is2FAEnabled, updateTimeRemaining]);

  const handleSetup2FA = () => {
    navigate('/2fa-setup');
  };

  const handleDismiss = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="bg-warning/10 border-b border-warning/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center flex-1">
            <Icon name="ShieldAlert" className="w-5 h-5 text-warning mr-3 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">
                Two-factor authentication required
              </p>
              <p className="text-xs text-foreground-secondary">
                You must enable 2FA {timeRemaining}. Secure your account now.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              onClick={handleSetup2FA}
              size="sm"
              className="bg-warning hover:bg-warning/90 text-white"
            >
              <Icon name="Shield" className="w-4 h-4 mr-2" />
              Set Up Now
            </Button>
            <button
              onClick={handleDismiss}
              className="text-foreground-secondary hover:text-foreground p-1"
            >
              <Icon name="X" className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFAReminderBanner;